import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

function SiteFooter() {
  const { t } = useLanguage();

  return (
    <footer className="ft-footer">
      <div className="rv-line ft-footer-line" />
      <div className="ft-footer-row">
        <span>© {new Date().getFullYear()} Furkan Turan</span>
        <span className="ft-footer-links">
          <Link to="/blog">{t.nav.writing}</Link>
          <Link to="/photos">{t.nav.photos}</Link>
        </span>
        <span>{t.footer.built}</span>
      </div>
    </footer>
  );
}

export default SiteFooter;
